import {isNotNil} from 'ramda-adjunct';

import {getLevelIndicatorFlags, LevelIndicator} from '@dms/shared';

import {Nullish} from 'shared/web';

import {toFuelTankRatio} from './toFuelTankRatio';

interface LevelRequestValues {
  fuelTank?: number | null;
  batteryCharge?: number | null;
}

/**
 * @about Maps the fuel tank and battery charge form fields onto a check-in, hand-over or
 * service order request body.
 *
 * A level the vehicle does not have is left out of the body entirely rather than sent as null,
 * so correcting a mis-recorded fuel type never erases a reading that is already stored.
 * The fuel tank is a 0–1 ratio on the wire and a percentage in the form; the battery charge is a
 * whole percentage in both, so it is only rounded — and only when it was actually recorded,
 * because `Math.round(null)` would save a fabricated 0 %.
 */
export const getLevelRequestValues = (
  values: {fuelTank?: number | Nullish; batteryCharge?: number | Nullish},
  levelIndicators: LevelIndicator[]
): LevelRequestValues => {
  const {hasFuel, hasBattery} = getLevelIndicatorFlags(levelIndicators);

  return {
    ...(hasFuel && {fuelTank: toFuelTankRatio(values.fuelTank)}),
    ...(hasBattery && {
      batteryCharge: isNotNil(values.batteryCharge) ? Math.round(values.batteryCharge) : null,
    }),
  };
};
